import React, { PureComponent } from 'react';
import { SaveButton, Toolbar, DeleteButton } from 'react-admin';
import DeleteAlertDialog from '../../../components/DeleteAlertDialog/DeleteAlertDialog';
import RemoveButton from '../../../components/RemoveButton/RemoveButton';

class SessionDetailToolbar extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  deleteExercise = () => {
    this.setState({ isOpen: true });
  };

  handleCloseModalDelete = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const { record, basePath, resource, ...props } = this.props;

    return (
      <>
        <Toolbar
          {...props}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            background: 'none',
          }}
        >
          <SaveButton {...props} label="save" submitOnEnter={false} />
          <RemoveButton variant="contained" deleteExercise={this.deleteExercise} />
        </Toolbar>
        <DeleteAlertDialog
          title="Delete Session"
          subtitle="Are you sure you want to delete session ?"
          description="Session will be deleted permanently and removed from all the programs where it appears."
          record={record}
          open={this.state.isOpen}
          handleClose={this.handleCloseModalDelete}
        >
          <DeleteButton
            redirect={`/programs/${record.program?.id}`}
            basePath={basePath}
            record={record}
            resource={resource}
          />
        </DeleteAlertDialog>
      </>
    );
  }
}

export default SessionDetailToolbar;
